import {
  ReactNode, createContext, useContext, useEffect, useMemo, useState,
} from 'react';

const IsWindowVisibleContext = createContext({
  isVisible: true,
});

export default function useIsWindowVisible() {
  return useContext(IsWindowVisibleContext);
}

export function IsWindowVisibleProvider({ children }: { children: ReactNode }) {
  const [isHidden, setIsHidden] = useState(false);

  function updateIsHidden() {
    setIsHidden(false);
  }

  function onVisibilityChange() {
    setIsHidden(document.hidden);
  }

  useEffect(() => {
    window.addEventListener('focus', updateIsHidden);
    window.addEventListener('mousemove', updateIsHidden);
    window.addEventListener('mouseout', updateIsHidden);
    window.addEventListener('mouseover', updateIsHidden);
    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => {
      window.removeEventListener('focus', () => updateIsHidden);
      window.removeEventListener('mousemove', updateIsHidden);
      window.removeEventListener('mouseout', updateIsHidden);
      window.removeEventListener('mouseover', updateIsHidden);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, []);

  const value = useMemo(() => ({ isVisible: !isHidden }), [isHidden]);

  return (
    <IsWindowVisibleContext.Provider value={value}>
      {children}
    </IsWindowVisibleContext.Provider>
  );
}
